<template>
  <v-dialog v-model="isOpen" max-width="480" aria-label="Delete account">
    <v-card>
      <v-card-title>Delete account?</v-card-title>
      <v-card-text>
        <p class="mb-3">
          This deletes your recipes, week plans, grocery list and profile, also
          for your family. You leave your family and the recipes shared with
          you.
        </p>
        <p class="mb-4">
          This can't be undone. Export your data first if you want to keep a
          copy.
        </p>
        <v-text-field
          v-if="usesPassword"
          v-model="password"
          label="Password"
          type="password"
          autocomplete="current-password"
          variant="outlined"
          hint="Enter your password to confirm"
          persistent-hint
        />
        <p v-else class="text-body-medium">
          You'll be asked to sign in with Google again to confirm.
        </p>
        <v-alert
          v-if="error"
          type="error"
          variant="tonal"
          density="compact"
          class="mt-4"
        >
          {{ error }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" :disabled="deleting" @click="close">
          Cancel
        </v-btn>
        <v-btn
          color="error"
          variant="flat"
          :loading="deleting"
          :disabled="usesPassword && !password"
          @click="$emit('confirm', password)"
        >
          Delete account
          <!-- Vuetify's own spinner has no accessible name -->
          <template v-slot:loader>
            <v-progress-circular
              indeterminate
              size="20"
              width="2"
              aria-label="Deleting account"
            />
          </template>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
  import { defineComponent, ref, watch } from 'vue';

  export default defineComponent({
    name: 'DeleteAccountDialog',
    props: {
      open: { type: Boolean, default: false },
      usesPassword: { type: Boolean, default: true },
      deleting: { type: Boolean, default: false },
      error: { type: String, default: '' },
    },
    emits: {
      confirm: (_password: string) => true,
      close: () => true,
    },
    setup(props, { emit }) {
      const isOpen = ref(props.open);
      const password = ref('');

      watch(
        () => props.open,
        (open) => {
          isOpen.value = open;
          password.value = '';
        },
      );
      watch(isOpen, (open) => {
        if (!open) emit('close');
      });

      return {
        isOpen,
        password,
        close() {
          isOpen.value = false;
        },
      };
    },
  });
</script>
